import { DataRefreshDto } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { HttpError } from '../../utils/errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const fetchDataRefreshTime: QueryFunction<DataRefreshDto> = async () => {
  const res = await portalGatewayClient.tenant.getDataRefreshTimestamp();
  if (res.ok) {
    return res.data.data;
  }

  throw new HttpError('Error fetching data refresh time', res.status);
};
